import * as React from 'react';
import * as styles from './style.css';
import { IconFunctionalInformationCircle16, Tooltip, UIHeading1, UIText1 } from '@cian/ui-kit';
import { VerticalSlider } from '../VerticalSlider';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';

interface IAwardsWrapperProps {
  title: string;
  sourceLabel: string;
  sourceUrl: string;
  id: string;
  onShow: () => void;
}

export const AwardsWrapper = ({
  id,
  children,
  title,
  sourceLabel,
  sourceUrl,
  onShow,
}: React.PropsWithChildren<IAwardsWrapperProps>) => {
  return (
    <section className={styles['wrapper']} id={id}>
      <div className={styles['title']}>
        <ActionAfterViewObserver callback={onShow} triggerOnce>
          <UIHeading1>{title}</UIHeading1>
        </ActionAfterViewObserver>
        <div className={styles['source']}>
          <UIText1 display="inline">{sourceLabel}</UIText1>
          <Tooltip title={`Источник: ${sourceUrl}`}>
            <div className={styles['description-icon']}>
              <IconFunctionalInformationCircle16 />
            </div>
          </Tooltip>
        </div>
      </div>
      <div className={styles['slider']}>
        <VerticalSlider arrow={() => null} containerClass={styles['slider-list']}>
          {children}
        </VerticalSlider>
      </div>
    </section>
  );
};
